import React, { useEffect } from 'react';
import { companyData } from '../data/content';
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  useEffect(() => {
    // Load Formaloo script dynamically
    const script = document.createElement('script');
    script.src = "https://embed.formaloo.me/v1/main.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Optional: cleanup if needed, but usually not required for this embed
    };
  }, []);

  return (
    <div className="bg-ms-light min-h-screen pt-12 pb-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-ms-blue font-black uppercase tracking-widest text-sm">Jetzt unverbindlich anfragen</span>
          <h1 className="text-5xl lg:text-7xl font-black text-ms-dark mb-6 uppercase tracking-tighter">Kontakt</h1>
          <p className="text-xl text-ms-dark/60 font-medium">Wir planen Ihr Projekt im Kreis Heinsberg & Umgebung.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {/* Contact Cards */}
          <div className="space-y-8">
            <div className="bg-white p-10 rounded-[2.5rem] shadow-xl border border-ms-blue/5">
              <h3 className="text-2xl font-black text-ms-dark mb-8 uppercase tracking-tighter">Direkt-Draht</h3>
              <div className="space-y-10">
                <div className="flex items-start">
                  <div className="bg-brand-gradient p-4 rounded-2xl mr-5 text-white shadow-lg">
                    <SafeIcon icon={FiPhone} />
                  </div>
                  <div>
                    <p className="text-xs text-ms-blue font-black uppercase tracking-widest mb-1">Mobil</p>
                    <a href={`tel:${companyData.phone.replace(/\s/g, '')}`} className="block text-xl font-bold text-ms-dark hover:text-ms-blue transition">{companyData.phone}</a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-brand-gradient p-4 rounded-2xl mr-5 text-white shadow-lg">
                    <SafeIcon icon={FiMail} />
                  </div>
                  <div>
                    <p className="text-xs text-ms-blue font-black uppercase tracking-widest mb-1">E-Mail</p>
                    <a href={`mailto:${companyData.email}`} className="block text-lg font-bold text-ms-dark hover:text-ms-blue transition break-all">{companyData.email}</a>
                  </div>
                </div>

                <div className="flex items-start pt-4 border-t border-ms-light">
                   <div className="bg-ms-light p-4 rounded-2xl mr-5 text-ms-blue">
                    <SafeIcon icon={FiMapPin} />
                  </div>
                  <div>
                    <p className="text-xs text-ms-dark/40 font-black uppercase tracking-widest mb-1">Standort</p>
                    <p className="text-sm font-bold text-ms-dark">{companyData.address}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Formaloo Form Integration */}
          <div className="lg:col-span-2 bg-white p-2 rounded-[3rem] shadow-2xl border border-ms-blue/5 overflow-hidden">
            <div className="p-8 lg:p-12">
              <h3 className="text-3xl font-black text-ms-dark mb-2 uppercase tracking-tighter">Anfrage senden</h3>
              <p className="text-ms-dark/50 font-bold text-sm uppercase tracking-widest mb-8">Wir melden uns innerhalb von 24 Stunden bei Ihnen.</p>
              
              <div className="rounded-[2rem] overflow-hidden border border-ms-light shadow-inner">
                {/* Formaloo Embed Container */}
                <div 
                  className="formaloo--root-container" 
                  data-form-slug="HBBEk1BM" 
                  style={{ width: '100%', height: '750px' }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;